export const Status = (status) => {
  switch (status) {
    case 1:
      return (
        <label className="btn m-0 p-0">
          <i class="text-success mx-1 bi bi-check-circle-fill"></i>
          Activo
        </label>
      );
    case 2:
      return (
        <label className="btn m-0 p-0">
          <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
          Pausado
        </label>
      );
    case 3:
      return (
        <label className="btn m-0 p-0">
          <i class="text-danger mx-1 bi bi-trash"></i>
          Eliminado
        </label>
      );
    case 4:
      return (
        <label className="btn m-0 p-0">
          <i class="text-info mx-1 bi bi-recycle"></i>
          Borrador
        </label>
      );
    default:
      return null;
      break;
  }
};
